import PageLayout from "../../components/layout/page";
import { DataView } from "../../components/table/table";
import { useApi } from "../../helper/apiHook";
import { useAddUpdate } from "../../helper/addUpdateHook";
import { AddUpdatePayment } from "./addUpdate";
import { Button } from "reactstrap";
import { plus } from "../../constant/icons";
import { columns } from "./columns";
import { useEffect } from "react";
import ModalView from "../../components/modal";

export const PaymentApi = (paging?: boolean, dataLoad: any = {},) => {
  return { ...useApi("/payment",paging, undefined, dataLoad) };
};

export default function Payment() {
  const api = PaymentApi(true);
  useEffect(() => {
    api.mutate();
  }, []);
  const AddUpdate = useAddUpdate();
  return AddUpdate.viewAddUpdate ? (
    <PageLayout
      View={
        <AddUpdatePayment
          closeAddUpdate={AddUpdate.closeAddEditFrom}
          api={api}
          value={AddUpdate.currentValue}
          currentPage={api.currentPage}
          rowCount={api.rowCount}
          limit={api.limit}
        />
      }
    />
  ) : (
    <>
      <PageLayout
        item={
          <Button
            color="secondary"
            onClick={() =>
              AddUpdate.openAddEditFrom({
                  vendor_type: "agency",
                  landlord_id:  "",
                  agency_id:  "",
                  personName: "",
                  remark : "",
                  paymentDate: new Date(),
                  amount:  "",
                  attachment:null,
              })
            }
          >
            {plus.icon}Add New
          </Button>
        }
        View={
          <DataView
            columns={columns({
              api,
              openAddEditFrom: AddUpdate.openAddEditFrom,
            })}
            rows={api.data}
            currentPage={api.currentPage}
            rowCount={api.rowCount}
            limit={api.limit}
            updatePagination={api.updatePagination}
          />
        }
      />
      {AddUpdate.viewAddUpdate && (
        <ModalView
          modalView={AddUpdate.viewAddUpdate}
          modalName={AddUpdate.currentValue?.id ? "Edit Payment" : "Add Payment"}
          onModalDismiss={AddUpdate.closeAddEditFrom}
        >
          <AddUpdatePayment
            closeAddUpdate={AddUpdate.closeAddEditFrom}
            api={api}
            value={AddUpdate.currentValue}
          />
        </ModalView>
      )}
    </>
  );
}


